/* @flow */
import * as React from 'react';
import { Route } from 'react-router';
import { connect } from 'react-redux';
import createDebugger from 'debug';
import * as Features from 'modules/features';
import * as Profile from 'modules/profile';
import { FeatureVerificationComponent } from './FeatureNotEnabledView';

const debug = createDebugger('app:components:App'); // eslint-disable-line no-unused-vars

import { getters as AppGetters, actions as AppActions } from 'modules/app';

/*

The `ToggleFeatureView` is a smart React Router View which renders its
routes conditionally based on a feature flag treatment.  If a feature treatment
matches the 'match' condition, then the `toggledComponent` will render.  If not, the `untoggledComponent` will render.

See the `ToggleFeature` Container to turn on/off elements at the React
render level.

How to use:
```
import { Route } from 'react-router';
import {
  ToggleFeatureView,
  FeatureNotEnabledView
} from 'trustar-2.0/containers/features';
import { flags as Flags, treatments as Treatments } from 'modules/features';

<Route path='/'>
  <Route
          path='dashboard'
          component={ToggleFeatureView}
          toggledComponent={DashboardContainer}
          untoggledComponent={FeatureNotEnabledView}
          feature={Flags.DASHBOARD_ENABLED}
          match={treatments.ON}
        />
</Route>
```
*/

class ToggleFeatureViewComponent extends React.Component {
  props: any;

  shouldComponentUpdate(nextProps, nextState) {
    return !(
      this.props.loadingTreatments === nextProps.loadingTreatments &&
      this.props.route.feature === nextProps.route.feature &&
      this.props.route.match === nextProps.route.match &&
      this.props.flagTreatment === nextProps.flagTreatment
    );
  }

  render() {
    const { flagTreatment, loadingTreatments, ...otherProps } = this.props;
    const { match } = this.props.route;

    const ToggledComponent = this.props.route.toggledComponent;
    const UntoggledComponent = this.props.route.untoggledComponent;

    if (loadingTreatments) {
      return <FeatureVerificationComponent />;
    }

    return match.match(flagTreatment) ? (
      <ToggledComponent {...otherProps} />
    ) : (
      <UntoggledComponent {...otherProps} />
    );
  }
}

export const mapStateToProps = (state: Object, ownProps: Object) => {
  const flagTreatment = Features.getters.getFlagTreatment(
    ownProps.route.feature
  )(state);

  const loadingTreatments =
    Features.getters.loading(state) || Profile.getters.loading(state);

  return {
    loadingTreatments: loadingTreatments,
    flagTreatment: Features.getters.getFlagTreatment(ownProps.route.feature)(
      state
    )
  };
};

export const ToggleFeatureView = connect(mapStateToProps)(
  ToggleFeatureViewComponent
);



// WEBPACK FOOTER //
// ./web_modules/trustar-2.0/containers/features/ToggleFeatureView.js